import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const PercentageIcon = ({
  width = 16,
  height = 16,
  stroke = '#A0A4A8',
  strokeWidth = 1.4,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M2.50781 12.5425L12.2635 2.7868"
      stroke={stroke}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="3.76238" cy="3.76262" r="1.80847" stroke={stroke} strokeWidth={strokeWidth} />
    <circle cx="11.2897" cy="11.288" r="1.80847" stroke={stroke} strokeWidth={strokeWidth} />
  </svg>
);
